import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
  Container,
  Typography,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
  Button,
  FormControl,
  FormLabel,
} from '@material-ui/core';

import { avatarPic, contactEmail } from './config';

function capitalize(str) {
  return (str || '').replace(/\b[a-z]/g, function(letter) {
      return letter.toUpperCase();
  });
}

export default function WorkTopicIntro({chatHost, avatarUrl}) {
  const topicName = 'work';

  useEffect(() => {
    window.localStorage['start_topic'] = topicName;
  }, [topicName]);
  
  const topicTitle = 'Thriving in the workplace';

  return (
    <Container component="main" maxWidth="md">
      <Typography variant="h3">{capitalize(topicTitle)}</Typography>

      <Typography paragraph style={{marginTop: 20}}>
        <img style={{float: "left", marginRight: 20}} width="200px" src={avatarPic}></img>
        Your will speak with Athena, who is our state-of the art AI coach, who will support you with issues related to the workpalce.
        <br/>
        <br/>
        This may include things like <i>work-life balance</i>, <i>interpersonal conflicts</i>, <i>inadequate training</i>, <i>low compensation</i> and more.
      </Typography>

      <Typography paragraph>
        <b>Please ensure your microphone and speakers are working and ready. Athena will understand you speaking voice, and will respond after a long pause in your speech.</b>
      </Typography>

      <form noValidate action={chatHost + '/submit-user-profile'} method="post">
        <input type="hidden" name="redirect" value={avatarUrl}/>
        <input type="hidden" name="user_agent" value={navigator.userAgent}/>

        <TextField
          variant="outlined"
          margin="normal"
          required
          fullWidth
          id="name"
          label="Your name"
          name="name"
          autoComplete="name"
        />

        <TextField
          variant="outlined"
          margin="normal"
          required
          fullWidth
          id="email"
          label="Your email address"
          name="email"
          autoComplete="email"
        />

        <FormControl key="1" component="fieldset" fullWidth margin="normal">
          <FormLabel component="legend">Gender</FormLabel>
          <RadioGroup row aria-label="gender" name="gender">
            <FormControlLabel value="male" control={<Radio required />} label="Male" />
            <FormControlLabel value="female" control={<Radio required />} label="Female" />
          </RadioGroup>
        </FormControl>


        <TextField
          variant="outlined"
          margin="normal"
          fullWidth
          name="about_job"
          label="Describe your role, job, and company"
          multiline
          minRows={5}
          id="about_job"
        />

        <TextField
          variant="outlined"
          margin="normal"
          fullWidth
          name="what_about_topic"
          label="What questions or challenges are you encountering at work? (List as many as you like)"
          multiline
          minRows={5}
          id="what_about_topic"
        />

        <Typography paragraph>
          <small>
            Your information will be kept confidential. Any advice given is not professional advice, and is for entertainment only. Please consult a professional if you are experiencing acute psychological distress or life challenges. This is an experimental AI technology.
            <br/>For more details, refer to: <a href="/terms.html" target="_blank">Terms of Use</a>, <a href="/privacy.html" target="_blank">Privacy Policy</a>, <a href={ 'mailto:' + contactEmail }>Contact</a>.
          </small>
        </Typography>

        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          style={{ margin: '24px 0' }}
        >
          Start Session
        </Button>

      </form>
    </Container>
  );
}
